var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"display":"flex","overflow":"hidden","padding-right":"6px"}},[_c('div',{staticStyle:{"width":"60%"},attrs:{"id":_vm.chartId}}),_c('div',{attrs:{"id":"radial-bar-chart-legend"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }